<template>
  <ModalDefault modal_id="addWalletModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :method="addWallet"
                :footer="add_wallet.department_id && add_wallet.operator_id"
                :modal_header="getTranslations('expression_691')"
                icon="bx bx-wallet mr-1">
    <div class="px-2 py-0" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-0 px-2">
              <div class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_12') }} </label>
                <div class="input-group mb-3">
                  <select v-model="add_wallet.department_id"
                          @change.prevent="add_wallet.operator_id = null"
                          class="input_forms custom-select">
                    <option :value="null">{{ getTranslations('expression_124') }}</option>
                    <option v-for="department in getDepartmentsArray('channel_id', leads.lead.channel_id)"
                            :key="department.id"
                            :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="add_wallet.department_id > 0" class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_48') }} </label>
                <div class="input-group mb-2">
                  <select v-model="add_wallet.operator_id" class="input_forms custom-select">
                    <option :value="null">{{ getTranslations('expression_692') }}</option>
                    <option v-for="operator in getOperatorsArray('department_id', add_wallet.department_id)"
                            :key="operator.id"
                            :value="operator.id">
                      {{ getUserObject('id', operator.user_id).name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
        <span @click.prevent="addWallet" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_693') }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalAddWallet",
  components: {
    ModalDefault,
  },
  data(){
    return {
      add_wallet: {
        operator_id: null,
        department_id: null
      },
    }
  },
  computed: {
    ...mapState(['leads']),
    ...mapGetters([
      'getUserObject',
      'getDepartmentsArray',
      'getOperatorsArray',
    ]),
  },
  mounted() {
    $('#addWalletModal').on('hidden.bs.modal', () => {
      this.add_wallet = {
        operator_id: null,
        department_id: null
      }
    })
  },
  methods: {
    addWallet() {
      this.add_wallet.channel_id = this.leads.lead.channel_id
      this.add_wallet.lead_id = this.leads.lead.id
      this.$store.dispatch('addWallet', this.add_wallet)
      $('#addWalletModal').modal('hide')
    }
  }
}
</script>

<style scoped>

</style>
